'use client';

import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import {
  Select,
  SelectItemProps,
} from '@sola/ark-core/molecules/select/select.js';
import { ARTICLE_URL_PARAMS } from '@sola/schema/lib/schema.js';

const showNumArticlesValues: SelectItemProps[] = [
  { value: '4' },
  { value: '8' },
  { value: '12' },
  { value: '24' },
];

export const ArticleFilter = ({ articleCount }: { articleCount?: number }) => {
  const router = useRouter();
  const searchParams = useSearchParams();
  const pathname = usePathname();
  const { t } = useTranslation();

  const params = useMemo(
    () => new URLSearchParams(searchParams?.toString()),
    [searchParams],
  );
  const sortByItems: SelectItemProps[] = [
    { text: t('skippy.article.sort.featured'), value: 'promotedContent' },
    { text: t('skippy.article.sort.newest'), value: 'desc' },
    { text: t('skippy.article.sort.oldest'), value: 'asc' },
  ];

  const handleChange =
    (key: string) => (e: React.ChangeEvent<HTMLInputElement>) => {
      const { value } = e.currentTarget;
      params.set(key, value);
      if (
        key === ARTICLE_URL_PARAMS.LIMIT ||
        key === ARTICLE_URL_PARAMS.SORTBY
      ) {
        params.set(ARTICLE_URL_PARAMS.PAGE, '0');
      }
      router.replace(`${pathname}?${params.toString()}`, { scroll: false });
    };

  return (
    <div className="ArticleFilter">
      <div className="ArticleFilter__container flex flex-col md:flex-row md:justify-between md:align-center gap-comfy-lg">
        <div className="body-md md:align-center">
          {articleCount
            ? t(`skippy.article.resultWithCount`, {
                count: articleCount,
              })
            : undefined}
        </div>
        <div className="flex align-end md:justify-end md:align-center gap-comfy-sm">
          <Select
            onChange={handleChange(ARTICLE_URL_PARAMS.SORTBY)}
            value={params?.get(ARTICLE_URL_PARAMS.SORTBY) || 'desc'}
            name="sort"
            items={sortByItems}
          />
          <Select
            onChange={handleChange(ARTICLE_URL_PARAMS.LIMIT)}
            value={
              params?.get(ARTICLE_URL_PARAMS.LIMIT) ||
              showNumArticlesValues[3].value
            }
            name="visibleArticles"
            items={showNumArticlesValues}
          />
        </div>
      </div>
    </div>
  );
};
